import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import {AnswerSecKill} from '../action/investmentAction.js';
import { Toast,Modal } from 'antd-mobile/lib';
import { AlertResule,AlertError } from './AnswerAlert'
import Util from '../util';


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class AnswerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chooseFlag:"C",
      alertFlag:false,
      content:"",
      AlertErrorFlag:false,
      chooseFlag2:"C",
      chooseFlag3:"C",
      
      count:0
    };

  }
  componentDidMount(){
  }
  componentWillMount(){
     window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  handleChoose(code,num){
    if(num == 1){
      this.setState({
        chooseFlag:code
      })
    }else if(num == 2){
      this.setState({
        chooseFlag2:code
      })
    }else if(num == 3){
      this.setState({
        chooseFlag3:code
      })
    }
    
  }
  submitChoose(){
    let {chooseFlag,chooseFlag2,chooseFlag3,} = this.state;
    let {dispatch} = this.props;
    let yesNum = 0;
    if(chooseFlag === "C" && chooseFlag2 === "C" && chooseFlag3 === "C" ){
      this.setState({
        AlertErrorFlag:true,
        content:"请先进行答题，再进行提交"
      })
      return
    }else{
        if(chooseFlag != "C"){
            yesNum += 1
        }
        if(chooseFlag2 != "C"){
            yesNum += 1
        }
        if(chooseFlag3 != "C"){
            yesNum += 1
        }
  
      
    }
    if(yesNum !=0){
      let inData = {
        count:yesNum
      }
      this.setState({
        count:yesNum
      })
      dispatch(AnswerSecKill(inData,this.callback.bind(this)))
    }else{
      this.setState({
        AlertErrorFlag:true,
        content:"答题完成，您共回答0道问题，很遗憾不能获得奖励"
      })
    }
   
  }
  callback(e){
    let {count} = this.state;
    console.log(e)
    if(e.code === "0000"){
        this.setState({
          alertFlag:true,
          content:"答题完成，您共回答" + count +  "道问题，请等待后续货币基金份额发放"
        })
      
    }else{
      this.setState({
        alertFlag:true,
        content:e.message
      })
    }
  }
  handleSure(){
    this.setState({
      AlertErrorFlag:false
    })
  }
  render(){
    let width = window.screen.width;
    let { chooseFlag,content,alertFlag,AlertErrorFlag, chooseFlag2, chooseFlag3 } = this.state;
    return (
        <div style={{background:"#0b0c44",position:'relative',width: width}}>
            <img
              src={require('../img/answerPage6.png')}
              alt=""
              style={{ width: width, verticalAlign: 'top'}}
            />
            <div className="questionOne" onClick={()=>{ this.handleChoose("A",1) }} style={{width:width, bottom:(width)/(750/1260)}}>
              <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
                  { chooseFlag === "A" ? 
                    <div className="answerChooseFlag"></div> : null
                  }
              </div>
            </div>

            <div className="questionTwo" onClick={()=>{ this.handleChoose("B",1) }} style={{width:width, bottom:(width)/(750/1158)}}>
                <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
                  {chooseFlag === "B" ?
                   <div className="answerChooseFlag"></div> : null
                  }
                </div>
            </div>

            <div className="questionOne" onClick={()=>{ this.handleChoose("A",2) }} style={{width:width, bottom:(width)/(750/942)}}>
              <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
                  { chooseFlag2 === "A" ? 
                    <div className="answerChooseFlag"></div> : null
                  }
              </div>
            </div>

            <div className="questionTwo" onClick={()=>{ this.handleChoose("B",2) }} style={{width:width, bottom:(width)/(750/855)}}>
                <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
                  {chooseFlag2 === "B" ?
                   <div className="answerChooseFlag"></div> : null
                  }
                </div>
            </div>

             <div className="questionOne" onClick={()=>{ this.handleChoose("A",3) }} style={{width:width, bottom:(width)/(750/532)}}>
              <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
                  { chooseFlag3 === "A" ? 
                    <div className="answerChooseFlag"></div> : null
                  }
              </div>
            </div>

            <div className="questionTwo" onClick={()=>{ this.handleChoose("B",3) }} style={{width:width, bottom:(width)/(750/448)}}>
                <div  style={{width:width*0.248, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
                  {chooseFlag3 === "B" ?
                   <div className="answerChooseFlag"></div> : null
                  }
                </div>
            </div> 




            <div className="sureAnswerBtn" style={{width:width, bottom:(width)/(750/265)}}>
              <div onClick={ ()=>{ this.submitChoose() }} style={{width:width*0.837, height:(width*0.637)/(478/101), background:"rgba(0,0,0,0)"}}>

              </div>
            </div>

            
            {
              AlertErrorFlag?<AlertError content={content} handleSure={this.handleSure.bind(this)}/> : null
            }
            {
              alertFlag?<AlertResule content={content} /> : null
            }
        </div>
    );
  }
}

/*
<div className="AnswerPage" style={{width:width, height:width/(750/1334) }}>
  <div className="questionOne" style={{width:width, bottom:(width)/(750/586)}}>
    <div onClick={()=>{ this.handleChoose("A") }} style={{width:width*0.786, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
        { chooseFlag === "A" ? 
          <div className="answerChooseFlag"></div> : null
        }
    </div>
  </div>
  <div className="questionTwo" style={{width:width, bottom:(width)/(750/416)}}>
    <div onClick={()=>{ this.handleChoose("B") }} style={{width:width*0.786, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
      {chooseFlag === "B" ?
       <div className="answerChooseFlag"></div> : null
      }
    </div>
  </div>
  <div className="sureAnswerBtn" style={{width:width, bottom:(width)/(750/162)}}>
    <div onClick={ ()=>{ this.submitChoose() }} style={{width:width*0.637, height:(width*0.637)/(478/101), background:"rgba(0,0,0,0)"}}>

    </div>
  </div>
</div>

*/

function mapStateToProps(state, ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(AnswerPage);



// WEBPACK FOOTER //
// ./src/components/AnswerPage.js